<template>
  <div class="pd-box">
    <div class="goods-img-box">
      <div class="goods-img">
        <img :src="_getPic(product.img || product.Logo, true)" class="goods-pic" alt="">
        <div v-if="product.IsOutBusinessScope" class="disable-type">
          {{ lang.Goods.Disabled_OverStep }}
        </div>
        <div v-else-if="product.IsSoldOut && fromPage == 'MyCollection'" class="disable-type">
          已下架
        </div>
        <div
          v-else-if="
            (!product.Stock || product.Stock <= 0) &&
              !product.IsSoldOut &&
              fromPage != 'isArriving' &&
              !product.EstimatedTime
          "
          class="disable-type"
        >
          {{ lang.Goods.Disabled_Undercarriage }}
        </div>
      </div>

      <!-- 距开始 -->
      <div v-if="product.countdownType === 1 && showGoodsTimeInGoods" class="goods-timer img-bs2 active-time no-start-colon">
        <!-- <span>距活动开始还有{{ timer.d }}天{{ timer.h }}时{{ timer.m }}分{{ timer.s }}秒</span> -->
        距活动开始仅剩{{ timer.d }}天
        <van-count-down :time="product.TotalMilliseconds">
          <template #default="timeData">
            <span class="block no-start-block">{{ timeData.hours > 9 ? timeData.hours : "0" + timeData.hours }}</span>
            <span class="colon no-start-colon">:</span>
            <span class="block no-start-block">{{ timeData.minutes > 9 ? timeData.minutes : "0" + timeData.minutes }}</span>
            <span class="colon no-start-colon">:</span>
            <span class="block no-start-block">{{ timeData.seconds > 9 ? timeData.seconds : "0" + timeData.seconds }}</span>
          </template>
        </van-count-down>
      </div>
      <!-- 距结束 -->
      <div v-else-if="product.countdownType === 2 && showGoodsTimeInGoods" class="goods-timer img-bs1 active-time">
        距活动结束仅剩{{ timer.d }}天
        <van-count-down :time="product.TotalMilliseconds">
          <template #default="timeData">
            <span class="block">{{ timeData.hours > 9 ? timeData.hours : "0" + timeData.hours }}</span>
            <span class="colon">:</span>
            <span class="block">{{ timeData.minutes > 9 ? timeData.minutes : "0" + timeData.minutes }}</span>
            <span class="colon">:</span>
            <span class="block">{{ timeData.seconds > 9 ? timeData.seconds : "0" + timeData.seconds }}</span>
          </template>
        </van-count-down>
      </div>
      <!-- 预计到货 -->
      <div v-if="product.EstimatedTime && getMomentStatus() && !product.Stock" class="goods-timer img-bs3">
        <span>预计到货需{{ firstTime[3] }}天</span>
      </div>

      <!-- 商品类型 -->
      <div v-if="false" class="goods-class" :class="{ 'goods-bs1': true, 'goods-bs2': false }">
        <div class="left">满减</div>
        <div class="ellips-text right">满1200元，可享受8.5折</div>
      </div>
    </div>
    <div>
      <div class="goods-tag-name">
        <!-- 医保标签 -->
        <div v-for="properties in product.CommodityListProperties" v-if="properties.AttributeName == '医保类型'" :key="properties.Id" style="font-size: 0;margin-right: 4px;">
          <img v-if="properties.Value == 1" src="@/assets/goods/class_a.png" width="28px" height="16px">
          <img v-if="properties.Value == 2" src="@/assets/goods/class_b.png" width="28px" height="16px">
          <img v-if="properties.Value == 3" src="@/assets/goods/yibao.png" width="28px" height="16px">
        </div>
        <!-- <template v-for="(tag, index) in tags">
          <div class="goods-tag tag-spe" :key="index">{{ tag.TagName }}</div>
        </template> -->
        <!-- 活动标签 -->
        <img v-if="tags && tags.length" :src="tags[0].TagImage" style="height: 16px;">
        <div
          v-if="
            product.NewProductTime &&
              moment().isBefore(moment(product.NewProductTime)) &&
              !tags.length
          "
          class="goods-tag tag-new"
        >
          新品
        </div>

        <!-- 商品标签 -->
        <div v-if="product.GoodsTags.length" class="goods-tag ">
          <img :src="product.GoodsTags[0].Img" style="width: 32px;height: 16px;">
        </div>
        <div class="goods-name ellips-text">
          {{ product.OperationName || product.SkuName }}
        </div>
      </div>
      <div class="goods-msg-item ellips-text">
        规格：{{ product.Specifications }}
      </div>
      <!-- 效期 -->
      <div v-if="product.AttributeName === '效期优于'" class="goods-msg-item ellips-text">
        {{ '效期优于：' + product.AttributeValue }}
      </div>

      <!-- 是否超出经营范围 -->
      <div v-if="!product.IsOutBusinessScope" class="goods-price">
        <!-- 判断配置方式 -->
        <div>
          <!-- 按商品配置 -->
          <div
            v-if="
              (!product.IsOutBusinessScope &&
                product.countdownType == 2 &&
                (activeCountdownType == 2 ||
                  activeShowGoodsTime == 1 ||
                  activeShowGoodsTime == 2)) ||
                (activeShowGoodsTime == 3 && product.countdownType == 0) ||
                (activeShowGoodsTime === 1 &&
                  product.countdownType == 0 &&
                  activeCountdownType == 0 &&
                  product.IsAdd &&
                  isZhuanQu)
            "
            style="display: flex;"
          >
            <!-- 活动开始，展示优惠价和原价 -->
            <template>
              <span v-if="product.IsShowOriginalPrice" class="old-money">¥ {{ product.PriceLimit }}</span>
              <div class="new-money">
                <span v-if="product.ActivityPrice" class="text">优惠价</span>
                <span style="font-size: 12px;">¥ </span>
                <span v-if="product.ActivityPrice">{{
                  product.ActivityPrice
                }}</span>
                <span v-else class="value">{{ product.PriceLimit }}</span>
              </div>
            </template>
          </div>
          <div
            v-else-if="
              IsOpenPreActivity &&
                (activeCountdownType == 1 || activeShowGoodsTime == 2)
            "
            style="display: flex;"
          >
            <!-- 活动未开始，价格展示问号 -->
            <template>
              <span v-if="product.IsShowOriginalPrice" class="old-money">¥ {{ product.PriceLimit }}</span>
              <div class="new-money">
                <span v-if="product.ActivityPrice" class="text">优惠价<span style="font-size: 12px;">¥ </span>{{ '?.??' }}</span>
                <span v-else class="value"> ¥ {{ product.PriceLimit }}</span>
              </div>
            </template>
          </div>
          <div v-else-if="showParams" style="display: flex;">
            <!-- 活动未开始，价格展示问号 -->
            <template>
              <span v-if="product.IsShowOriginalPrice" class="old-money">¥ {{ product.PriceLimit }}</span>
              <div class="new-money">
                <span v-if="product.ActivityPrice" class="text">优惠价<span style="font-size: 12px;">¥ </span>{{ '?.??' }}</span>
                <span v-else class="value"> ¥ {{ product.PriceLimit }}</span>
              </div>
            </template>
          </div>

          <!-- <div v-else
                         style="display: flex;">
                        <template>
                            <span class="old-money"
                                  v-if="product.IsShowOriginalPrice">¥ {{product.PriceLimit}}</span>
                            <div class="new-money">
                                <span class="text"
                                      v-if="product.ActivityPrice">优惠价</span>
                                <span class="value"
                                      else> ¥ {{product.ActivityPrice}}</span>
                            </div>
                        </template>
                    </div> -->
        </div>
        <!-- <div v-else>
                    <template>
                        <span class="money">¥ {{ product.PriceLimit?product.PriceLimit.toFixed(2):'' }}</span>
                    </template>
                </div> -->
      </div>

      <div v-if="!product.IsOutBusinessScope" class="goods-disc">
        <span>
          最低零售价 ¥{{ Number(product.RetailPrice).toFixed(2) }} | 毛利率
          {{
            _showProductProfit(
              product.RetailPrice,
              _getProductPrice(product.ActivityPrice, product.PriceLimit)
            ) + '%'
          }}
        </span>
      </div>
      <div v-if="!product.IsOutBusinessScope && parseInt(product.Stock) > 0" class="goods-bottom">
        <div
          v-if="
            (((activeShowGoodsTime === 3 &&
              (activeCountdownType === 2 || product.countdownType === 0)) ||
              (activeShowGoodsTime === 2 &&
                (product.countdownType === 2 || product.countdownType == 0)) ||
              (activeShowGoodsTime == 1 && !IsOpenPreActivity) ||
              (activeShowGoodsTime == 1 &&
                product.countdownType === 0 &&
                activeCountdownType === 0)) &&
              product.IsAdd) ||
              showParams
          "
          style="flex:1"
          @click.stop="clickStop"
        >
          <van-stepper v-model="cartNum" :min="product.PurchaseNumber" :disable-plus="cartNum >= product.Stock" :step="product.StepLengthNumber" integer />
        </div>
        <!-- <div style="flex:1;text-align: right;"
                     v-else-if="!product.IsAdd">
                    <a-button type="primary"
                              class="join-btn-ready">即将开始</a-button>
                </div> -->
        <div
          v-if="
            (((activeShowGoodsTime === 3 &&
              (activeCountdownType === 2 || product.countdownType === 0)) ||
              (activeShowGoodsTime === 2 &&
                (product.countdownType === 2 || product.countdownType == 0)) ||
              (activeShowGoodsTime == 1 && !IsOpenPreActivity) ||
              (activeShowGoodsTime == 1 &&
                product.countdownType === 0 &&
                activeCountdownType === 0)) &&
              product.IsAdd) ||
              showParams
          "
          style="flex:1;text-align: right;"
        >
          <a-button type="danger" class="join-btn" @click.stop="confirmCart">加入购物车</a-button>
        </div>
      </div>
      <div v-if="product.IsOutBusinessScope" class="err-bottom">
        <span>超出经营范围</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { BaseMixin } from '@/mixins/BaseMixin'
import { CollectType } from '@/dictionary/goods.js'
export default {
  name: 'SpecialGoodsItem',
  mixins: [BaseMixin],
  props: {
    showGoodsTimeInGoods: {
      type: Boolean,
      default: false
    },
    isShowAdd: {
      type: Boolean,
      default: false
    },
    showParams: {
      type: Boolean,
      default: false
    },
    showGoodsTime: {
      // 是否商品上展示倒计时
      type: Number,
      default: null
    },
    // 活动配置类型
    ConfigType: {
      type: Number,
      default: null
    },
    // 专区上的countdownType
    countdownType: {
      type: Number,
      default: null
    },
    IsOpenPreActivity: {
      // 是否开启预热
      type: Boolean,
      default: () => false
    },
    timer: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tags: {
      type: Array,
      default: () => []
    },
    product: {
      type: Object,
      default: () => {
        return {}
      }
    },
    fromPage: {
      type: String,
      default: null
    },
    isOldBuy: {
      type: Boolean,
      default: false
    },
    activeCountdownType: {
      type: Number,
      default: null
    },
    isZhuanQu: {
      type: Boolean,
      default: false
    },
    activeShowGoodsTime: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      value: 1,
      Enum_CollectType: CollectType,
      firstTime: [],
      color: ['red', 'orange', 'blue', 'green'],
      goodsActivity: {},
      timerFun: {},
      collects: {
        Goods: { Id: '', IsCollect: false },
        Subscribe: { Id: '', IsCollect: false }
      },
      cartNum: 0,
      url: {
        addOrUpdateCart: '/api_order/ShoppingCarts/AddOrUpdateCart',
        createLike: '/api_customer/CustomerCollect/Create', // 客户收藏&订阅到货通知
        deleteLike: '/api_customer/CustomerCollect/PhysicalDeleteBatch', // 客户取消收藏&到货通知
        getCollect: '/api_customer/CustomerCollect/IsCollect' // 是否收藏&订阅
      },
      addCarLoading: false
    }
  },
  watch: {
    isOldBuy: {
      handler(val) {
        const { Id } = this.product
        const { firstAddWithOldBuyId } = this.$attrs
        if (firstAddWithOldBuyId === Id && val) {
          console.log('以原价')
          this.confirmCart()
        }
      }
    }
  },
  created() {
    this.goodsActivity = this._analysisGoodsActivity(
      this.product.SalesPromotions
    )
    this.product.goodsActivity = this.goodsActivity
    // 倒计时显示顺序  即将到货 < 新品 < 特价
    let productTime = this.product.NewProductTime // 新品截止时间

    if (!this.product.NewProductTime) {
      productTime = this.product.EstimatedTime // 预计到货时间
    } else if (this.fromPage == 'isArriving') {
      productTime = this.product.EstimatedTime
    } else if (this.goodsActivity) {
      productTime = this.goodsActivity.FirstEnd.EndTime
    }

    const timer = (productTime) => {
      const array = this._analysisActivityDiffTime(productTime, moment())
      const firstTime = this._setTimerArr(array[1])
      let flag = true
      const constDays = array[0].length > 1 ? array[0] : '0' + array[0]
      firstTime.push(constDays)
      firstTime.push(array[0])
      firstTime.forEach((t) => {
        if (Number(t) < 0) {
          clearInterval(this.timertimerFun)
          flag = false
        }
      })
      if (flag) {
        this.firstTime = firstTime
      }
    }
    if (productTime) {
      timer(productTime)
      this.timerFun = setInterval(timer(productTime), 1000)
    }
  },
  methods: {
    moment,
    getMomentStatus() {
      const { EstimatedTime } = this.product
      return moment().isBefore(moment(EstimatedTime))
    },
    clickStop() { },
    // 确认购物车
    async confirmCart() {
      if (this.isShowAdd && !this.isOldBuy) {
        // 判断是否有资格购买
        this.$emit('handleClick', this.product.Id)
      } else {
        if (this.cartNum > this.product.Stock) {
          this.$toast({
            position: 'bottom',
            message:
              '购买商品数量超过了该商品库存，库存余（' +
              this.product.Stock +
              '）'
          })
          this.cartNum = this.product.Stock
          return false
        }
        if (
          !!this.product.LimitPerOrder &&
          this.cartNum > this.product.LimitPerOrder
        ) {
          this.$toast({
            position: 'bottom',
            message:
              '单笔订单限购（' +
              this.product.LimitPerOrder +
              '）' +
              this.product.Unit
          })
          this.cartNum = this.$hys.checkLimitPerOrder(
            this.product.PurchaseNumber,
            this.product.StepLengthNumber,
            this.product.LimitPerOrder
          )
          return false
        }
        this.product.cartNum = this.cartNum
        const toastLoading = this.$toast.loading({
          message: '',
          duration: 0,
          forbidClick: true
        })
        const res = await this.postAction(this.url.addOrUpdateCart, {
          ProductSKUId: this.product.Id,
          SourceGoodsSkuId: this.product.SourceGoodsSkuId,
          IsPrice: this.isOldBuy,
          Count: this.product.cartNum,
          IsAdd: true
        })
        if (res.IsSuccess) {
          toastLoading.clear()
          this.$nextTick(() => {
            if (res.Data.CountData) {
              // 判断是否可以加购
              if (res.Data.IsLimitPerOrder) {
                this.$toast({
                  position: 'bottom',
                  message:
                    '单笔订单限购（' +
                    this.product.LimitPerOrder +
                    '）' +
                    this.product.Unit
                })
                return false
              }
              this.$bus.$emit(
                'buycarChanged',
                res.Data.CountData.ProductCount,
                true
              )
              this.$bus.$emit(
                'rightBuycarChanged',
                res.Data.CountData.ProductCount,
                true
              )
            }
            this.$toast({ position: 'center', message: '添加购物车成功' })
          })
        } else {
          toastLoading.clear()
          this.$toast({ position: 'bottom', message: res.Msg })
        }
      }
    },
    // 操作订阅收藏
    async operateCollect(collectType) {
      const key =
        collectType == this.Enum_CollectType.Goods ? 'Goods' : 'Subscribe'
      const isCollect = this.collects[key].IsCollect
      const collectId = this.collects[key].Id
      if (isCollect) {
        this.cancelCollect(collectType, key, collectId)
      } else {
        this.setCollect(collectType, key)
      }
    },
    // 订阅&收藏
    async setCollect(collectType, key) {
      const title =
        collectType == this.Enum_CollectType.Goods ? '收藏成功' : '订阅成功'
      const data = {
        CollectType: collectType,
        CollectingBusinessId: this.product.Id,
        CollectionPrice: this._getProductPrice(
          this.product.ActivityPrice,
          this.product.PriceLimit
        )
      }
      const res = await this.postAction(`${this.url.createLike}`, data)
      // console.log('收藏订阅', res)
      if (res.IsSuccess) {
        this.collects[key].Id = res.Data
        this.collects[key].IsCollect = true
        this.product.ArrivalNotices = true
        this.$toast(title)
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 取消订阅&收藏
    async cancelCollect(collectType, key, collectId) {
      const title =
        collectType == this.Enum_CollectType.Goods
          ? '取消收藏成功'
          : '取消订阅成功'
      this.$hys.openLoading()
      const res = await this.deleteAction(
        `${this.url.deleteLike}?ids=${collectId}`
      )
      this.$hys.clearLoading()
      // console.log('取消收藏订阅', res)
      if (res.IsSuccess) {
        this.collects[key].Id = ''
        this.collects[key].IsCollect = false
        this.product.ArrivalNotices = false
        this.$toast(title)
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    async getCollect(collectType) {
      const res = await this.getAction(
        `${this.url.getCollect}?collectingBusinessId=${this.product.Id}`
      )
      // console.log('获取收藏订阅详情', res)
      if (res.IsSuccess) {
        const data = res.Data
        const goodsCollects = data.filter(
          (item) => item.CollectType == this.Enum_CollectType.Goods
        )
        const subscribeCollects = data.filter(
          (item) => item.CollectType == this.Enum_CollectType.Subscribe
        )
        if (goodsCollects.length > 0) {
          this.collects['Goods'].Id = goodsCollects[0].Id
          this.collects['Goods'].IsCollect = true
        }
        if (subscribeCollects.length > 0) {
          this.collects['Subscribe'].Id = subscribeCollects[0].Id
          this.collects['Subscribe'].IsCollect = true
          this.product.ArrivalNotices = true
        }
        this.operateCollect(collectType)
      } else {
        //   this.$toast(res.Msg)
      }
    }
  }
}
</script>

<style scoped lang="less">
.pd-box {
  background: #ffffff;
  border-radius: 2px;
  box-sizing: border-box;
  padding: 8px;
  width: 100%;
  text-align: left;
  height: 100%;
}
/deep/ .van-stepper__minus {
  background: #fff;
  border-radius: 2px 0px 0px 2px;
  border: 1px solid #c5cad5;
}
/deep/ .van-stepper__input {
  border-top: 1px solid #c5cad5;
  border-bottom: 1px solid #c5cad5;
  background: #fff;
  margin: 0;
}
/deep/ .van-stepper__plus {
  border-radius: 0 2px 2px 0;
  border: 1px solid #c5cad5;
  background: #fff;
  &:active {
    background-color: #c5cad5;
  }
}
.pd-box:hover .goods-pic {
  transform: scale(1.05);
}
.goods-pic {
  width: 100%;
  height: 100%;
  transition: all 0.6s;
}
.img-bs1 {
  background: #ffeae7;
}

.colon {
  display: inline-block;
  margin: 0 2px;
  color: #ff3939;
}

.block {
  display: inline-block;
  width: 17px;
  height: 17px;
  color: #fff;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  background-color: #ff3939;
  border-radius: 3px;
}

.no-start-block {
  background-color: #f98900;
}
.img-bs2 {
  background: #fff3e5;
}
.img-bs3 {
  background: rgba(17, 26, 52, 0.6);
}
.goods-bs1 {
  background: linear-gradient(328deg, #ff6831 0%, #f3180e 100%);
}
.goods-bs2 {
  background: linear-gradient(328deg, #4898ff 0%, #0f6eea 100%);
}
.goods-class {
  width: 100%;
  height: 28px;
  border-radius: 8px 8px 0px 0px;
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: 0;
  line-height: 28px;
  padding: 0 12px;
  box-sizing: border-box;
  display: flex;
  color: #fff;
  font-size: 12px;
}
.goods-class .left {
  margin-right: 8px;
}
.goods-class .right {
  flex: 1;
  width: 0;
}
.goods-timer {
  width: 100%;
  height: 28px;
  // border-radius: 8px 8px 0px 0px;
  position: absolute;
  text-align: center;
  z-index: 1;
  left: 0;
  bottom: 0;
  line-height: 28px;
  padding: 0 12px;
  box-sizing: border-box;
  font-size: 12px;
  color: #fff;
}
.active-time {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ff3939;
}
.no-start-colon {
  color: #f98900;
}

.goods-img-box {
  position: relative;
  width: 100%;
  height: 210px;
  background: #f3f5f8;
  overflow: hidden;
}
.disable-type {
  width: 129px;
  height: 129px;
  background: rgba(17, 26, 52, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.goods-img {
  width: 100%;
  height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ellips-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.goods-tag-name {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.goods-tag {
  border-radius: 4px;
  margin-right: 8px;
  font-size: 12px;
  color: #fff;
  padding: 2px 4px;
  line-height: 1;
}
.tag-spe {
  background: #f98900;
}
.tag-new {
  background: #490fea;
}
.goods-name {
  color: #111a34;
  font-size: 16px;
  font-weight: bold;
  flex: 1;
}
.get-goods {
  width: 100%;
  height: 32px;
  background: #0f6eea;
  border-radius: 2px;
}
.err-bottom {
  color: #0f6eea;
  font-size: 16px;
  margin-top: 14px;
}
.goods-msg-item {
  color: #666f83;
  margin-top: 4px;
  line-height: normal;
}
.money {
  color: #ff3939;
  font-size: 20px;
  margin-right: 8px;
}
.new-money {
  height: 20px;
  background: linear-gradient(137deg, #ff6831 0%, #f3180e 100%);
  border-radius: 4px;
  color: #fff;
  line-height: 20px;
  display: flex;
  align-items: center;
  padding: 0 6px;
}
.new-money .text {
  font-size: 12px;
  margin-right: 4px;
}
.new-money .value {
  font-size: 16px;
}
.old-money {
  color: #858b9c;
  text-decoration: line-through;
  margin-right: 8px;
}
.goods-price {
  margin-top: 10px;
  display: flex;
}
.goods-disc {
  color: #666f83;
  font-size: 12px;
  margin-top: 4px;
}
.goods-bottom {
  margin-top: 14px;
  display: flex;
  align-items: center;
}
.join-btn {
  background: #f60707;
  border-radius: 2px;
  width: 86px;
  height: 32px;
  padding: 0 8px;
}
</style>
